var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 800,
    viewBox: "0 0 1024 1024",
    width: 800,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m891.881933 421.488537c-4.233766-8.531013-12.894812-13.868527-22.399539-13.868526h-167.279313v-287.218264a24.943894 24.943894 0 0 0 -7.291087-17.64564c-4.690419-4.687347-11.071272-7.35764-17.712192-7.35764l-327.978115.066553c-13.801974 0-25.00328 11.198234-25.003279 25.00328v287.152734h-169.815477c-9.507799 0-18.165773 5.337514-22.399539 13.868527-4.233766 8.498248-3.256979 18.685907 2.473707 26.240133l357.60526 471.275985a25.136385 25.136385 0 0 0 19.92276 9.834419 25.013518 25.013518 0 0 0 19.925833-9.8979l357.473179-471.212504c5.73171-7.554226 6.707473-17.742909 2.477802-26.241157z",
    fill: "#27323a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m512.005119 810.78612 267.749085-353.158526h-102.555426c-13.801974 0-25.00328-11.201305-25.00328-25.00328v-259.008175c-39.132897.033788-238.835586.066553-277.970531.066553v258.941622c0 13.801974-11.198234 25.00328-25.00328 25.00328h-105.058825z",
    fill: "#79ccbf"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m204.734062 457.627594c47.860496 63.029357 274.976691 362.276225 307.272081 404.859615 32.298463-42.583391 259.284624-341.830259 307.142048-404.859615h-42.029468l-265.11258 349.708032-265.239541-349.708032z",
    fill: "#f4ce73"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m374.224967 145.031308h277.970531v33.338731h-277.970531z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.c03adf5e.svg";
export { ForwardRef as ReactComponent };